<template>
  <div>
    <el-form>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <el-input v-model="oldStr" type="textarea" :autosize="{minRows: 10, maxRows: 50}" placeholder="Original text"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-input v-model="newStr" type="textarea" :autosize="{minRows: 10, maxRows: 50}" placeholder="Changed text"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Show Option: ">
            <el-switch v-model="viewMode" active-text="Line-by-line" inactive-text="Side-by-side"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <code-diff :old-string="oldStr" :new-string="newStr" :context="context" :output-format="outputFormat" />
  </div>
</template>

<script>
import codeDiff from './lib/index.js'
export default {
  name: 'App',
  components: {
    codeDiff
  },
  data () {
    return {
      oldStr: '',
      newStr: '',
      viewMode: false,
      context: 5
    }
  },
  computed: {
    outputFormat () {
      return this.viewMode ? 'line-by-line' : 'side-by-side'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue